var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_1223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24.0001L2.06346 17.8142C0.611972 15.3656 0.0952314 12.4746 0.608619 9.67476C1.12201 6.87496 2.63087 4.35537 4.85669 2.58106C7.08252 0.806755 9.87505 -0.102493 12.7188 0.021146C15.5626 0.144785 18.2657 1.29296 20.3292 3.25376C22.3926 5.21455 23.6771 7.85558 23.9455 10.6894C24.214 13.5232 23.4483 16.3584 21.7898 18.6718C20.1313 20.9852 17.6919 22.6205 14.9219 23.276C12.1519 23.9315 9.23829 23.5628 6.71887 22.238L0 24.0001Z",
    fill: "#2CB742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5691 14.4969C17.0788 13.8643 16.4672 13.3359 15.7703 12.9425C15.4502 12.7605 15.0643 12.7396 14.8813 13.0649C14.7016 13.2851 14.5092 13.4946 14.3051 13.6925C14.1954 13.7843 14.0686 13.8534 13.9319 13.8956C13.7952 13.9377 13.6515 13.9522 13.5092 13.938C13.3669 13.9239 13.2288 13.8815 13.1031 13.8133C12.9774 13.7451 12.8665 13.6524 12.7771 13.5408L11.6162 12.3797L10.4554 11.2187C10.3444 11.1292 10.2523 11.0186 10.1845 10.8933C10.1166 10.7679 10.0744 10.6303 10.0603 10.4884C10.0462 10.3466 10.0605 10.2033 10.1022 10.067C10.144 9.93076 10.2125 9.80416 10.3037 9.69462C10.5015 9.49049 10.7111 9.29805 10.9312 9.11826C11.2565 8.93521 11.2366 8.54923 11.0536 8.22915C10.6603 7.53208 10.1319 6.92045 9.49949 6.43001C9.34929 6.35043 9.17754 6.3211 9.00945 6.34633C8.84137 6.37155 8.68579 6.45001 8.56556 6.57018L8.05311 7.08272C6.42684 8.70927 7.22795 10.545 8.85317 12.1705L10.3435 13.6601L11.8296 15.1464C13.4559 16.773 15.2913 17.5732 16.9165 15.9466L17.429 15.4341C17.5498 15.3136 17.6287 15.1574 17.6539 14.9886C17.6792 14.8199 17.6494 14.6474 17.5691 14.4969Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_1223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.bb5951afb6373b4395adb285cdec7980.svg";
export { ForwardRef as ReactComponent };